import React, { FunctionComponent } from "react";

import List from "../../List";
import RecipeCard from "../../RecipeCard";
import { RecipePreview } from "../../../types/recipePreview";

type ExtraContentRecipesListProps = {
  data: {
    title?: string | null;
    description?: string | null;
    cta?: string | null;
    recipes: {
      selectRecipesRelated: RecipePreview[];
    };
  };
};

const ExtraContentRecipesList: FunctionComponent<
ExtraContentRecipesListProps
> = ({ data }) => {
  return (
    <List
        header={<h2>{data.title}</h2>}
        items={data.recipes.selectRecipesRelated.map((recipe) => (
          <RecipeCard key={recipe._id} recipe={recipe} />
        ))}
        singularLabel='recipe'
        pluralLabel='recipes'
      />
  );
};

export default ExtraContentRecipesList;
